// extracted by mini-css-extract-plugin
module.exports = {"container":"ManageChild_container__3IFXS","formLabel":"ManageChild_formLabel__36a5R"};